import React from 'react'
import DoctorLogin from '../../components/DoctorLogin/DoctorLogin'

function DoctorLoginPage() {
  return (
    <DoctorLogin></DoctorLogin>
  )
}

export default DoctorLoginPage